"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Solution MZ for client FE
 * Api Consumer Solution MZ
 *
 * The version of the OpenAPI document: v1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorResponseMessageCodeEnum = void 0;
/**
    * @export
    * @enum {string}
    */
var ErrorResponseMessageCodeEnum;
(function (ErrorResponseMessageCodeEnum) {
    ErrorResponseMessageCodeEnum["ErrorSolutionsPdaEventConflict"] = "ERROR_SOLUTIONS_PDA_EVENT_CONFLICT";
    ErrorResponseMessageCodeEnum["ErrorSolutionsIdEventOccurrenceConflict"] = "ERROR_SOLUTIONS_ID_EVENT_OCCURRENCE_CONFLICT";
    ErrorResponseMessageCodeEnum["ErrorSolutionsConflict"] = "ERROR_SOLUTIONS_CONFLICT";
    ErrorResponseMessageCodeEnum["ErrorSolutionsKeyAlreadyUsed"] = "ERROR_SOLUTIONS_KEY_ALREADY_USED";
    ErrorResponseMessageCodeEnum["ErrorSolutionsKeyNotFound"] = "ERROR_SOLUTIONS_KEY_NOT_FOUND";
    ErrorResponseMessageCodeEnum["ErrorSolutionsFieldValidation"] = "ERROR_SOLUTIONS_FIELD_VALIDATION";
    ErrorResponseMessageCodeEnum["ErrorSolutionsFormMetadataFieldConfigurationMissing"] = "ERROR_SOLUTIONS_FORM_METADATA_FIELD_CONFIGURATION_MISSING";
    ErrorResponseMessageCodeEnum["ErrorSolutionsFormMissingMandatoryField"] = "ERROR_SOLUTIONS_FORM_MISSING_MANDATORY_FIELD";
})(ErrorResponseMessageCodeEnum || (exports.ErrorResponseMessageCodeEnum = ErrorResponseMessageCodeEnum = {}));
